import React, { PropsWithChildren, useContext, useMemo } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";
import { useTheme } from "@mui/material";
import { UnisphereProvider } from "@unisphere/runtime-react";
import { UnisphereWorkspaceConfig } from "@unisphere/runtime";

/*
 * z-index of DOM elements that Unisphere renders on the body tag.
 * They should be on top of all regular elements on the page, and below MUI modals (1300 by default)
 */
const unisphereZIndex = 1000;

/**
 * Render Unisphere provider, initialized with values from KMS configs
 */
export const KmsUnisphereProvider = ({ children }: PropsWithChildren) => {
    const config = useContext(ConfigContext);
    const serverUrl = config.application.unisphereWorkspaceUrl;
    const application = config.application.isKAF ? "KAF" : "KMS";
    const theme = useTheme();

    const unisphereConfig = useMemo<UnisphereWorkspaceConfig>(
        () => ({
            serverUrl,
            appId: application,
            runtimes: [
                {
                    widgetName: "unisphere.widget.notifications",
                    runtimeName: "notifications",
                    settings: {},
                    runtimeArea: {
                        target: "body",
                    },
                    ui: {
                        bodyContainer: {
                            zIndex: unisphereZIndex,
                        },
                    },
                },
            ],
            ui: {
                bodyContainer: {
                    zIndex: unisphereZIndex,
                },
            },
        }),
        [serverUrl, application]
    );

    return (
        <UnisphereProvider
            initialConfiguration={unisphereConfig}
            kalturaTheme={theme.kaltura}
            language={config.application.currentLocaleCode ?? "en"}
        >
            {children}
        </UnisphereProvider>
    );
};
